
import React from "react";
import {ProductStructList} from "../structs/ProductStructList";
import {ProductStruct} from "../structs/ProductStruct";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Paper from "@material-ui/core/Paper";
import ListItemText from "@material-ui/core/ListItemText";
import {BASE_URL_API, PRODUCT_BASE_URL_API} from "../Const";
import {Link} from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

export class ProductComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            productList: [],
        }
    }

    componentDidMount() {
        fetch(BASE_URL_API + 'product?market_id=' + this.props.market_id + '&category_id=' + this.props.category_id, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {

                    let data = new ProductStructList();

                    for (let i = 0; i < results.data.length; i++) {
                        if (data.productList.length > 0) {
                            let size = data.productList.length;
                            for (let j = 0; j < size; j++) {
                                if (results.data[i].category !== null && data.productList[j].category === results.data[i].category.title) {
                                    data.productList[j].productList.push(results.data[i])

                                    break
                                } else {
                                    if (j === data.productList.length - 1) {
                                        let productStruct = new ProductStruct()
                                        productStruct.category = results.data[i].category.title
                                        productStruct.productList.push(results.data[i])
                                        data.productList.push(productStruct)

                                    }
                                }
                            }
                        } else {
                            let productStruct = new ProductStruct()
                            productStruct.category = results.data[i].category.title
                            productStruct.productList.push(results.data[i])
                            data.productList.push(productStruct)
                        }


                    }

                    this.setState({productList: data.productList})
                },
                (error) => {
                    console.log("error")
                }
            );
    }

    render() {

        const flexContainer = {
            display: 'flex',
            flexDirection: 'row',
            overflowX: 'auto',
            overflowY: 'hidden',
            background: 'rgba(238,238,238,0.3)',
            height: 240,
            align: 'right'
        };

        const MAX_LENGTH = 20;

        return (this.state.productList.map((product) => (
                <Box key={product.id} style={{overflowX: 'hidden', overflowY: 'hidden', height: 300}}>

                    <Grid container >
                        <Grid item xs={8} sm={10} md={10} lg={11}>
                            <ListItemText style={{margin:16}}><strong>{product.category}</strong></ListItemText>

                        </Grid>
                        <Grid item xs={4} sm={2} md={2} lg={1}>
                            <a style={{marginBottom: 20,color: 'gray',fontSize:14}} href={"/product-list/?market_id=" + this.props.market_id+"&category_id="+product.productList[0].category.id}>{'مشاهده همه>'}</a>
                        </Grid>

                    </Grid>

                    <List key={product.id} style={flexContainer}>
                        {product.productList.map((product) => (

                            <ListItem key={product.id} style={{width: 180}} component={Link}
                                      to={"/product/?id=" + product.id}>

                                <div style={{width: 150}}>
                                    <Paper style={{
                                        width: 150,
                                        height: 140,
                                        align: 'center',
                                        backgroundPosition: 'center',
                                        backgroundSize: 'cover',
                                        backgroundImage: 'url(' + (product.pictures.length > 0 ? PRODUCT_BASE_URL_API + product.pictures[0].url : "https://hamekara.com/hamekara-logo.png") + ')'
                                    }}>

                                    </Paper>
                                    <ListItemText>
                                        {product.title.length > MAX_LENGTH ?
                                            (
                                                <p key={product.id} style={{
                                                    fontSize: 14,
                                                    overflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    color: 'black'
                                                }}
                                                   align='right'><strong>{`${product.title.substring(0, MAX_LENGTH)}...`}</strong></p>
                                            ) :
                                            <p key={product.id} style={{
                                                fontSize: 14,
                                                overflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                color: 'black'
                                            }}
                                               align='right'><strong>{product.title}</strong></p>
                                        }

                                        {product.del_price > 0 ?
                                            (
                                                <React.Fragment>
                                                    <p key={product.id} style={{
                                                        fontSize: 12,
                                                        overflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        color: 'gray',
                                                        textDecorationLine: 'line-through'
                                                    }}
                                                       align='left'><strong>{`${product.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} تومان `}</strong></p>

                                                    <p key={product.id} style={{
                                                        fontSize: 14,
                                                        overflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        color: 'green'
                                                    }}
                                                       align='left'><strong>{`${(parseInt(product.price) - parseInt(product.del_price)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} تومان `}</strong></p>
                                                </React.Fragment>

                                            ) :
                                            <React.Fragment>
                                                <p key={product.id} style={{
                                                    fontSize: 14,
                                                    overflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    color: 'green'
                                                }}
                                                   align='left'><strong>{`${ product.price > 0 ? product.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +` تومان ` : `تماس بگیرید.`}`}</strong></p>
                                            </React.Fragment>
                                        }


                                    </ListItemText>
                                </div>

                            </ListItem>

                        ))
                        }
                    </List>
                </Box>

            ))
        );

    }

}

